<template>
	<v-container class="pa-0">
		<div class="px-2">
			<h2 class="mt-2">Añada los documentos o complete los campos indicados</h2>
			<span style="color: rgba(0, 0, 0, 0.6) !important;"><b>Los archivos añadidos se guardan
					automáticamente.</b>
				Puede
				abandonar esta página y volver a ella más adelante para continuar la subsanación. Acceda desde los
				correos
				electrónicos que ha recibido, o desde Umivale Activa online si es despacho usuario de la
				plataforma.</span>
		</div>
		<v-row class="mt-2 px-2">
			<v-col class="mx-auto">
				<v-alert color="#124D91" text>
					<img alt="info" src="@Base/assets/info.svg" height="30px"
						style="margin: 10px 25px 0 10px; float: left;" />
					<ul style="color: #595959; font-size: 1em; padding-left: 72px; display: block;"
						class="alternar-dots">
						<li>
							<b>¿Necesita enviar un documento de varias páginas?</b>
						</li>
						<li>
							Los campos admiten un solo archivo. Puede agrupar varios documentos comprimiéndolos en un
							único
							archivo zip.
						</li>
						<li>
							<b>¿No dispone de un escáner?</b>
						</li>
						<li>
							Es suficiente con una foto de buena calidad, aunque preferimos el formato pdf.
						</li>
						<li>
							La aportación de <b>documentos incorrectos</b> podrá exigir su subsanación.
						</li>
					</ul>
				</v-alert>
			</v-col>
		</v-row>

		<v-skeleton-loader v-if="isLoading" type="card" class="mb-4 mx-auto" />

		<div v-if="subsanacion && subsanacion.categorias.length > 0">
			<Categoria v-for="categoria in subsanacion.categorias" :key="categoria.id" :categoria="categoria"
				:campos="getCamposByCategoria(categoria)" @combinacion-changed="combinacionChanged"
				@documento-changed="documentoChanged" @alert-event="$emit('alert-event', $event)" />
		</div>

		<v-row v-if="!isLoading" class="my-6">
			<v-col>
				<v-btn class="btn-next" style="float:right;" :disabled="disableContinuar" @click="continueNext()"
					color="primary">Continuar
				</v-btn>
			</v-col>
		</v-row>

	</v-container>
</template>

<script>
import api from '@Base/services/auditoriaService';
import StepBase from './common/StepBase';
import Categoria from './common/Categoria';

export default {
	name: 'SubsanacionesMain',
	mixins: [StepBase],
	components: {
		Categoria
	},
	data() {
		return {
			isLoading: false,
			subsanacion: null,
			selectedCombinacionByCampo: [],
			estadoActual: [],
			disableContinuar: true,
		}
	},
	computed: {
	},
	methods: {
		getCamposByCategoria(categoria) {
			var campos = this.subsanacion.campos.filter(x => x.idCategoria == categoria.id);
			campos = campos.sort((a, b) => a.orden - b.orden);
			return campos;
		},
		combinacionChanged(combinacion) {
			var index = this.selectedCombinacionByCampo.findIndex(x => x.idCampo == combinacion.idCampo);

			if (index == -1) {
				this.selectedCombinacionByCampo.push({ idCampo: combinacion.idCampo, idCombinacion: combinacion.idCombinacion });
			} else {
				this.selectedCombinacionByCampo[index].idCombinacion = combinacion.idCombinacion;
			}

			this.estaSubsanacionCompletada();
		},
		documentoChanged(documento) {
			var campo = this.subsanacion.campos.find(x => x.id == documento.idCampo);
			var combinacion = campo.combinacionDocs.find(x => x.id == documento.idCombinacion);
			var doc = combinacion.documentos.find(x => x.id == documento.idDocumento);

			doc.idSolDocumento = documento.idSolDocumento;
			doc.nombreArchivo = documento.nombreArchivo;

			this.estaSubsanacionCompletada();
		},
		estaSubsanacionCompletada() {
			if (this.selectedCombinacionByCampo.length == 0) {
				return;
			}

			var countDocsObligatoriosByCampo = [];

			for (var i = 0; i < this.subsanacion.campos.length; i++) {
				var campo = this.subsanacion.campos[i];

				var selectedCombinacion = this.selectedCombinacionByCampo.find(x => x.idCampo == campo.id);

				if (!selectedCombinacion) {
					continue;
				}

				var combinacion = campo.combinacionDocs.find(x => x.id == selectedCombinacion.idCombinacion);

				var numObligatorios = combinacion.documentos.filter(x => x.obligatorio == 'S').length;
				var numObligatoriosConArchivo = combinacion.documentos.filter(x => x.obligatorio == 'S' && x.idSolDocumento && x.nombreArchivo).length;

				countDocsObligatoriosByCampo.push({ idCampo: campo.id, numObligatorios: numObligatorios, numObligatoriosConArchivo: numObligatoriosConArchivo });
			}

			// Si el numero de campos no coincide, no continuamos
			if (this.subsanacion.campos.length != countDocsObligatoriosByCampo.length) {
				this.disableContinuar = true;
				return;
			}

			var numCamposConDocumentosObligatoriosSinArchivos = 0;

			for (var k = 0; k < countDocsObligatoriosByCampo.length; k++) {
				var numDocsObligatorios = countDocsObligatoriosByCampo[k].numObligatorios;
				var numDocsObligatoriosConArchivo = countDocsObligatoriosByCampo[k].numObligatoriosConArchivo;

				if (numDocsObligatorios != numDocsObligatoriosConArchivo) {
					numCamposConDocumentosObligatoriosSinArchivos++;
				}
			}

			this.disableContinuar = numCamposConDocumentosObligatoriosSinArchivos > 0;
		},
		continueNext() {
			this.$router.push({ name: 'declaraciones', params: { id: this.$store.state.solicitud.tokenAcceso, notificacion: !this.$store.state.solicitud.idNotificacion ? this.$store.state.solicitud.audFirma.notificacionOrigen : this.$store.state.solicitud.idNotificacion } });
		},
		getSubsanacion() {
			this.isLoading = true;
			this.subsanacion = null;

			api.getSubsanacion(
				res => {
					this.isLoading = false;
					this.subsanacion = res;

					this.$nextTick(function () {
						this.estaSubsanacionCompletada();
					});
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al obtener la subsanación', color: 'red' });
					console.log(error);
				}
			);

		},
		putSubsanacion() {
			this.isLoading = true;

			api.putSubsanacion(
				res => {
					this.isLoading = false;

					if (res) {
						this.$refs.dlgCanalesAcceso.open(res, msg => this.doShowAlert(msg));
					}
				},
				error => {
					this.isLoading = false;
					this.$emit('alert-event', { text: 'Error al establecer la subsanación', color: 'red' });
					console.log(error);
				});
		},
	},
	watch: {
		$route(to) {
			this.$store.commit('solicitud/setTituloModulo', this.$store.state.solicitud.solicitante.tituloPrestacion);
			this.$store.commit('solicitud/setPasoActual', 2);
			this.getSubsanacion();
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.$store.commit('solicitud/setTituloModulo', vm.$store.state.solicitud.solicitante.tituloPrestacion);
			vm.$store.commit('solicitud/setPasoActual', 2);
			vm.getSubsanacion();
		})
	},
	beforeMount() {
		window.onbeforeunload = () => {
			return "¿Estás seguro de abandonar la página? Los cambios no guardados se perderán.";
		};
	},
	beforeDestroy() {
		window.onbeforeunload = null; // Eliminar el evento antes de destruir el componente
	}
}

</script>
<style>
/* Estilo para todos los elementos de la lista */
.alternar-dots li {
	list-style: none;
	/* Oculta los puntos en todos los elementos */
	margin-left: 1em;
	/* Añade un margen izquierdo para la sangría */
	position: relative;
	/* Permite la posición relativa para los elementos li */
	color: rgba(0, 0, 0, 0.6) !important;
}

/* Estilo para elementos pares */
.alternar-dots li:nth-child(odd)::before {
	content: "\2022";
	/* Agrega un punto (•) como contenido antes del elemento */
	position: absolute;
	/* Permite la posición absoluta para los puntos */
	left: -1em;
	/* Ajusta la posición del punto a la izquierda */
	margin-right: 0.5em;
	/* Añade un espacio entre el punto y el texto */
}

/* Estilo para elementos pares (sin punto) */
.alternar-dots li:nth-child(even) {
	margin-bottom: 0.5em;
	/* Añade espacio entre los elementos sin punto y el siguiente */
}
</style>